// Utils
import { addObjectPaths } from './addObjectPaths';
/**
 * Get the paths of every object(represented in dot notation), identified by the object id
 * @example
 * inputValue = {
 *   x: 1,
 *   _objectId: '1',
 *   y: {
 *     _objectId: '2',
 *   },
 *   a: '2',
 *   z: [
 *     {
 *       _objectId: '3',
 *     }
 *   ]
 * }
 * outputValue = {
 *   'OID:1': '',
 *   'OID:2': 'invoice_lines.0',
 *   'OID:3': 'invoice_lines.1',
 *   'OID:4': 'invoice_lines.1.invoice_lines.0'
 * }
 * @template T extends IndexedStore<any>
 * @param {T} values
 *
 * @return {IndexedStore<string>}
 */
export var createObjectPaths = function (values) {
    var objectPaths = {};
    addObjectPaths(values, objectPaths, '');
    return objectPaths;
};
//# sourceMappingURL=createObjectPaths.js.map